import React, { type ReactNode } from "react";

import styled from "styled-components";
import { LoadingSpinner } from "components/shared/loading-spinner";

const StyledWrapper = styled.div`
  color: ${(props) => props.theme.colors.uiDark};
  position: absolute;
  top: 150px;
  left: 50%;
  transform: translateX(-50%);
  display: grid;
`;

const StyledIndicator = styled.div`
  position: absolute;
  top: -10px;
  right: -10px;
  bottom: -10px;
  left: -10px;
  z-index: ${(props) => props.theme.layering.overlay};
`;

const StyledLoader = styled.div`
  position: relative;
`;

interface ILoaderProps {
  children?: ReactNode;
}

function Loader({ children }: ILoaderProps) {
  return (
    <StyledLoader role="status">
      <StyledIndicator>
        <StyledWrapper>
          <LoadingSpinner />
          {children}
        </StyledWrapper>
      </StyledIndicator>
    </StyledLoader>
  );
}

export default Loader;
